var _path, _g, _path2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgForehead = function SvgForehead(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 13,
    height: 15,
    x: 8,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12.383.564 8.528 10.142-4.383 3.685L8 4.25z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m11.265 7.726.23-1.023a4.2 4.2 0 0 1 1.808.128q.855.26 1.408.919.555.66.664 1.545.108.886-.184 1.803l-1.047.052q.199-.72.15-1.41a2.08 2.08 0 0 0-.495-1.223 2.08 2.08 0 0 0-1.119-.698 4.2 4.2 0 0 0-1.415-.093m.482-2.143.23-1.023q1.364-.139 2.582.307 1.219.447 1.977 1.349.759.902.99 2.18a5.7 5.7 0 0 1-.141 2.595l-1.047.051q.288-1.17.113-2.227a3.74 3.74 0 0 0-.827-1.832 3.74 3.74 0 0 0-1.663-1.13q-1.012-.353-2.214-.27"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6 22v-4.3a9.2 9.2 0 0 1-2.212-3.037A8.8 8.8 0 0 1 3 11q0-3.75 2.625-6.375C8.25 2 9.5 2 12 2q3.125 0 5.538 1.837c2.413 1.837 2.654 2.821 3.137 4.788l1.375 5.45a.68.68 0 0 1-.125.638.72.72 0 0 1-.6.287H19v3.5q0 .62-.44 1.06T17.5 20H15v2h-1.5v-3.5h4v-5h2.85L19.225 9q-.6-2.425-2.625-3.963Q14.575 3.5 12 3.5q-3.125 0-5.313 2.162Q4.501 7.825 4.5 10.938q0 1.611.658 3.06a8.1 8.1 0 0 0 1.867 2.577l.475.45V22z"
  }))));
};
export default SvgForehead;